import React from 'react';
import { Typography } from 'antd';
import './index.less';
import PropTypes from 'prop-types';

const { Text } = Typography;

function KPICard({
  number,
  afterNumber,
  title,
  subTitle,
}) {
  return (
    <div className="KPICard">
      <Text copyable={{ text: number.toFixed(2) }} className="Number">
        {+number.toFixed(2)}
        {afterNumber && <span className="AfterNumber">{afterNumber}</span>}
      </Text>
      <div className="Title">{title}</div>
      {subTitle && <div className="SubTitle">{subTitle}</div>}
    </div>
  );
}

KPICard.propTypes = {
  number: PropTypes.number.isRequired,
  afterNumber: PropTypes.string,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
};
KPICard.defaultProps = {
  afterNumber: '',
  subTitle: '',
};

export default KPICard;
